exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-calendar-picker{width:100%}.ant-calendar-range-picker-separator{line-height:2.2}.ant-calendar-range-middle{width:auto;line-height:3}", ""]);

